/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteLease (id: number) {
  return rest.delete(`/api/leases/${id}`)
}

export function fetchLease (id: number): Promise<Lease> {
  return rest.get(`/api/leases/${id}`)
    .then((resp) => resp.json())
}

export function fetchLessorByEstateIdAndDate (estateId: number, date: string): Promise<Customer> {
  return rest.get(`/api/leases/lessor-by-estateId-and-date?${stringify({
    estateId,
    date
  })}`)
    .then((resp) => resp.json())
}

export function findManyLeases (params?: Record<string, any>): Promise<HalDocument<{
  leases: Lease[]
}>> {
  return rest.get(`/api/leases?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function findManyLeasesAlerts () {
  return rest.get('/api/leases/alerts')
    .then((resp) => resp.json())
}

export function patchLease (id: number, data: Partial<Lease>) {
  return rest.patch(`/api/leases/${id}`, {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function postLease (data: Partial<Lease>) {
  return rest.post('/api/leases', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}
